module.exports = __webpack_public_path__ + "img/6.c06a86e7.png";